// extracted by mini-css-extract-plugin
export default {"root":"_2VA2s"};